// 20250619 - src/Modal/ModalRoot.js - a component at the bottom of view/Dashboard.js
/* <ModalRoot /> is rendered at the top level of Dashboard.js 
*                in the very bottom of the "render()" section that will allow modals to appear anywhere in the app.
*               It is triggered by dispatching actions 
*                (e.g., showModal('INCIDENT_IMAGES', { images: [...] })) 
*                from components like Dashboard.js.
*               see src/actions/modal.js with const showModal for more info
*              USING REDUX IS AN OLD WAY TO USE MODALS AND IS NOW REPLACED BY THE USE OF CONTEXT AND HOOKS
*              THIS SYSTEM SHOULD AT SOME POINT UP THE REDUX AND MODAL USE (xt 6/20/25)
*   20260814: xt: added email report button in actions
*/

import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import FullscreenIncidentChatModal from './FullscreenIncidentChatModal'
import IncidentChatModal from './IncidentChatModal'
import IncidentEmailModal from './IncidentEmailModal'; // 8/14/26 xt added for prod
import IncidentImagesModal from './IncidentImagesModal' // also has .css file
import IncidentLogModal from './IncidentLogModal'
import IncidentMapModal from './IncidentMapModal'   // also has .css file
import IncidentNotesModal from './IncidentNotesModal'
import IncidentResourceModal from './IncidentResourceModal'  // also has .css file
import SelectDepartmentModal from './SelectDepartmentModal'
import SelectRoleModal from './SelectRoleModal'
import SelectShiftModal from './SelectShiftModal'
import SelectStartDateModal from './SelectStartDateModal'  // also has .css file
import SelectUnitModal from './SelectUnitModal'
import { hideModal } from '../../actions/modal'; // for debug modal
import EmptyModal from './EmptyModal'; // for debug modal?
import './Modal.css'

// this should really be modal root component - i think JY and BD messed up names
const MODAL_COMPONENTS = {
  'SELECT_DEPARTMENT': SelectDepartmentModal,
  'SELECT_UNIT': SelectUnitModal,
  'SELECT_ROLE': SelectRoleModal,
  'SELECT_SHIFT': SelectShiftModal,
  'SELECT_START_DATE': SelectStartDateModal,
  'INCIDENT_CHAT': IncidentChatModal,
  'FULL_INCIDENT_CHAT': FullscreenIncidentChatModal,
  'INCIDENT_EMAIL': IncidentEmailModal,
  'INCIDENT_NOTES': IncidentNotesModal,
  'INCIDENT_IMAGES': IncidentImagesModal,
  'INCIDENT_MAP': IncidentMapModal,
  'INCIDENT_LOG': IncidentLogModal,
  'INCIDENT_RESOURCE': IncidentResourceModal,
  'EMPTY_MODAL': EmptyModal,
}

// 

const ModalRoot = ({ modalType, modalProps, visible, hideModal }) => {
  console.log('ModalRoot rendering:', { modalType, modalProps, visible });

  if (!modalType) {
    console.log('ModalRoot: No modalType needed yet, returning null');
    return null;
  }

  const SpecificModal = MODAL_COMPONENTS[modalType];
  if (!SpecificModal) {
    console.log('ModalRoot: Unknown modalType:', modalType);
    return null;
  }

  // Special case: INCIDENT_CHAT should receive props directly (not nested)
  if (modalType === 'INCIDENT_CHAT') {
    return (
      <IncidentChatModal
        {...modalProps}      // spreads incident, agencyId, reportSchemaId, etc.
        visible={visible}
        hideModal={hideModal}
      />
    );
  }

  // Default case for all other modals listed above
  return (
    <SpecificModal
      modalProps={modalProps || {}} // props stay nested as before
      visible={visible}
      hideModal={hideModal}
    />
  );
};

//export default connect(state => state.modal)(ModalRoot) // original code before Bootstrap 5 upgrade..
ModalRoot.propTypes = {
  modalType: PropTypes.string,
  modalProps: PropTypes.object,
  visible: PropTypes.bool,
  hideModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  modalType: state.modal?.modalType,
  modalProps: state.modal?.modalProps || {},
  visible: state.modal?.visible || false,
});
// this connect ModalRoot to REDUX and the state
export default connect(mapStateToProps, { hideModal })(ModalRoot);
